module.exports = __webpack_public_path__ + "static/media/theIowa.083f9297.jpg";